import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getRezyme = (params) => {
    return axios.get(`${backendHost}/api/admin/report-games/group`, {params});
};

export {
    getRezyme
}